import { FontWeight, Heading } from '@lili/lili-frontend-common';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../Icon';
import BackIcon from '../../assets/svg/backArrow.svg';

export interface PageHeaderProps {
  title: string;
  showBackButton?: boolean;
  pathToNavigate?: string;
}

const PageHeader = (props: PageHeaderProps) => {
  const { title, showBackButton = true, pathToNavigate } = props;
  const navigate = useNavigate();

  return (
    <div className='flex items-center gap-[18px] mb-[24px]' id='header'>
      {showBackButton && (
        <button
          onClick={() => (pathToNavigate ? navigate(pathToNavigate) : navigate(-1))}
          className='cursor-pointer w-[10px]'
          type='button'
        >
          <Icon src={BackIcon} />
        </button>
      )}
      <Heading.H5 fontWeight={FontWeight.MEDIUM}>{title}</Heading.H5>
    </div>
  );
};

export default PageHeader;
